import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmSidebarComponent } from '@shared/component/sidebar/confirm-sidebar/confirm-sidebar.component';
import { ConfirmSidebar } from '@shared/models/sidebar.model';

@Component({
  selector: 'app-error-template-side-bar',
  imports: [ConfirmSidebarComponent, TranslateModule],
  template: `
    <app-confirm-sidebar [data]="data">
      @if (data?.icon) {
        <img src="{{ data?.icon }}" alt="receipt-error.svg" class="pb-4" />
      } @else {
        <img src="assets/images/receipt-error.svg" alt="receipt-error.svg" class="pb-4" />
      }
      <p
        class="w-full text-center mt-2 px-3"
        style="font-size: 16px"
        [innerHTML]="data.contentMessage | translate"
      ></p>
    </app-confirm-sidebar>
  `
})
export class ErrorTemplateSideBarComponent {
  @Input() data: ConfirmSidebar = {};
}
